import axios from 'shared/utils/axiosInstance';

const getUser = async () => axios.get('/user');
const signout = async () => axios.post('/user/signout');
const signin = async (data) => axios.post('/user/signin', data);
const resetPassword = async (data) => axios.post('/user/password-reset', data);
const requestPasswordReset = async (data) => axios.post('/user/password-reset-request', data);

export { getUser, signout, signin, resetPassword, requestPasswordReset };
